import { useMemo } from "react";
import { useSelector } from "react-redux";
import { currentUser, currentOnlineCheckout } from "./../redux/slice/UserSlice";

export const useAuth = () => {
  const user = useSelector(currentUser);
  const onlineCheckout = useSelector(currentOnlineCheckout);
  return useMemo(() => ({ user, onlineCheckout }), [user, onlineCheckout]);
};